var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-invoice"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invoice",
    clipPath: "url(#clip-invoice)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15835",
    "data-name": "Group 15835",
    transform: "translate(7306.015 10629.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18542",
    "data-name": "Path 18542",
    d: "M89.237,38.229h-.2a2.6,2.6,0,0,1-2.42-1.64,1.2,1.2,0,0,0-2.218,0,2.6,2.6,0,0,1-2.42,1.64h-.109a2.6,2.6,0,0,1-2.42-1.64,1.2,1.2,0,0,0-2.218,0,2.6,2.6,0,0,1-2.42,1.64H74.7a2.6,2.6,0,0,1-2.42-1.64,1.2,1.2,0,0,0-2.218,0,2.6,2.6,0,0,1-2.42,1.64h-.2A3.439,3.439,0,0,1,64,34.794V3.435A3.439,3.439,0,0,1,67.435,0h.2a2.6,2.6,0,0,1,2.42,1.64,1.2,1.2,0,0,0,2.218,0A2.6,2.6,0,0,1,74.7,0h.109a2.6,2.6,0,0,1,2.42,1.64,1.2,1.2,0,0,0,2.218,0A2.6,2.6,0,0,1,81.865,0h.109a2.6,2.6,0,0,1,2.42,1.64,1.2,1.2,0,0,0,2.218,0A2.6,2.6,0,0,1,89.033,0h.2a3.439,3.439,0,0,1,3.435,3.435v31.36A3.439,3.439,0,0,1,89.237,38.229ZM85.5,33.45A3.569,3.569,0,0,1,88.83,35.7a.221.221,0,0,0,.2.142h.2a1.046,1.046,0,0,0,1.045-1.045V3.435a1.046,1.046,0,0,0-1.045-1.045h-.2a.221.221,0,0,0-.2.142,3.585,3.585,0,0,1-6.652,0,.221.221,0,0,0-.2-.142h-.109a.22.22,0,0,0-.2.142,3.585,3.585,0,0,1-6.652,0,.221.221,0,0,0-.2-.142H74.7a.22.22,0,0,0-.2.142,3.585,3.585,0,0,1-6.652,0,.221.221,0,0,0-.2-.142h-.2a1.046,1.046,0,0,0-1.045,1.045v31.36a1.046,1.046,0,0,0,1.045,1.045h.2a.22.22,0,0,0,.2-.142,3.585,3.585,0,0,1,6.652,0,.221.221,0,0,0,.2.142h.109a.22.22,0,0,0,.2-.142,3.585,3.585,0,0,1,6.652,0,.221.221,0,0,0,.2.142h.109a.22.22,0,0,0,.2-.142A3.569,3.569,0,0,1,85.5,33.45Z",
    transform: "translate(-7364.683 -10628.91)",
    fill: "#5c6d7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18543",
    "data-name": "Path 18543",
    d: "M196.779,121.557a2.389,2.389,0,1,1,2.389-2.389,1.195,1.195,0,1,0,2.389,0,4.787,4.787,0,0,0-3.584-4.627v-1.346a1.195,1.195,0,0,0-2.389,0v1.346a4.779,4.779,0,0,0,1.195,9.406,2.389,2.389,0,1,1-2.389,2.389,1.195,1.195,0,1,0-2.389,0,4.787,4.787,0,0,0,3.584,4.627v1.346a1.195,1.195,0,1,0,2.389,0v-1.346a4.779,4.779,0,0,0-1.195-9.406Z",
    transform: "translate(-7483.126 -10732.548)",
    fill: "#5c6d7e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.0cad38d1266ba22776df790347fb1f6f.svg";
export { ForwardRef as ReactComponent };